import { render } from "./BirthMonthPage.vue?vue&type=template&id=3eeef63f&scoped=true"
import script from "./BirthMonthPage.vue?vue&type=script&lang=js"
export * from "./BirthMonthPage.vue?vue&type=script&lang=js"

import "./BirthMonthPage.vue?vue&type=style&index=0&id=3eeef63f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3eeef63f"]])

export default __exports__